import { render, staticRenderFns } from "./accordion-tab.vue?vue&type=template&id=6785f902&"
import script from "./accordion-tab.vue?vue&type=script&lang=js&"
export * from "./accordion-tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports